__turbopack_context__.v({
  "bulletClass": "PromoBannerSlider-module-scss-module__wW0pjW__bulletClass",
  "buttonDisabled": "PromoBannerSlider-module-scss-module__wW0pjW__buttonDisabled",
  "navigationButtonNext": "PromoBannerSlider-module-scss-module__wW0pjW__navigationButtonNext",
  "navigationButtonPrev": "PromoBannerSlider-module-scss-module__wW0pjW__navigationButtonPrev",
  "navigationButtons": "PromoBannerSlider-module-scss-module__wW0pjW__navigationButtons",
  "paginationPoints": "PromoBannerSlider-module-scss-module__wW0pjW__paginationPoints",
  "root": "PromoBannerSlider-module-scss-module__wW0pjW__root",
  "slide": "PromoBannerSlider-module-scss-module__wW0pjW__slide",
  "swiper": "PromoBannerSlider-module-scss-module__wW0pjW__swiper",
});
